import { css } from 'styled-components';

const placeholderMixin = css`
  color: #777 !important;
  font-style: italic;
  opacity: 1 !important;
`;

export default placeholderMixin;
